import { Button } from 'bootstrap';
import './cargaTabla.css';
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import './ajustes.css';
export default function Ajustes() {
  const [cookies, setCookie] = useCookies(['user']);
  const [logsCompletos, setLogsCompletos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [emp, setEmp] = useState([]);
  const [carga, setCarga] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const empl = await axios.get('https://back.agsseguros.online/api/login/usuariosAllAjustes');
        setEmp(empl.data);
        const solicitudes = await axios.get('https://reclamosback.agsseguros.online/apiReclamos/logsCompletos/all');
        setLogsCompletos(solicitudes.data);
        const usuariosRes = await axios.get('https://reclamosback.agsseguros.online/apiReclamos/user/allAjustes');
        setUsuarios(usuariosRes.data);
        setCarga(1);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchData();
  }, []);
  let updatedList = logsCompletos;
  let updatedUser = usuarios;
  let updatedEmp = emp;
  const [info, setInfo] = useState({ fechaCompleto: '', enviadoSharepoint: '', enviadoDigi: '', borradoVPS: '', fechaBorradoVPS: '', nroStro: '', patente3ro: '' });
  const [infoUser, setInfoUser] = useState({ nombre: '', apellido: '', email: '' });
  const [infoEmp, setInfoEmp] = useState({ nombre: '', apellido: '', email: '', user: '', area: '', depto: '' });
  const handleChange = e => {
    const { name, value } = e.target;
    setInfo(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeUser = e => {
    const { name, value } = e.target;
    setInfoUser(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeEmp = e => {
    const { name, value } = e.target;
    setInfoEmp(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const conFiltro = () => {
    if (info.fechaCompleto && info.fechaCompleto !== '' && info.fechaCompleto !== '0000-00-00') {
      updatedList = updatedList.filter(d => d.fechaCompleto === info.fechaCompleto);
    }
    if (info.enviadoSharepoint && info.enviadoSharepoint !== '') {
      const valorFiltro = info.enviadoSharepoint === 'true';
      updatedList = updatedList.filter(d => d.sharepointCompleto === valorFiltro);
    }
    if (info.enviadoDigi && info.enviadoDigi !== '') {
      const valorFiltro = info.enviadoDigi === 'true';
      updatedList = updatedList.filter(d => d.enviadoDigi === valorFiltro);
    }
    if (info.borradoVPS && info.borradoVPS !== '') {
      const valorFiltro = info.borradoVPS === 'true';
      updatedList = updatedList.filter(d => d.borrado === valorFiltro);
    }
    if (info.fechaBorradoVPS && info.fechaBorradoVPS !== '' && info.fechaBorradoVPS !== '0000-00-00') {
      updatedList = updatedList.filter(d => d.fechaBorrado === info.fechaBorradoVPS);
    }
    if (info.nroStro && info.nroStro !== '') {
      updatedList = updatedList.filter(d => String(d.nroStro).toLowerCase().includes(String(info.nroStro).toLowerCase()));
    }
    if (info.patente3ro && info.patente3ro !== '') {
      updatedList = updatedList.filter(d => d.patente3ro && d.patente3ro.toLowerCase().includes(info.patente3ro.toLowerCase()));
    }
    if (infoUser.nombre && infoUser.nombre !== '') {
      updatedUser = updatedUser.filter(d => d.nombre && d.nombre.toLowerCase().includes(infoUser.nombre.toLowerCase()));
    }
    if (infoUser.apellido && infoUser.apellido !== '') {
      updatedUser = updatedUser.filter(d => d.apellido && d.apellido.toLowerCase().includes(infoUser.apellido.toLowerCase()));
    }
    if (infoUser.email && infoUser.email !== '') {
      updatedUser = updatedUser.filter(d => d.email && d.email.toLowerCase().includes(infoUser.email.toLowerCase()));
    }
    if (infoEmp.email && infoEmp.email !== '') {
      updatedEmp = updatedEmp.filter(d => d.email && d.email.toLowerCase().includes(infoEmp.email.toLowerCase()));
    }
    if (infoEmp.user && infoEmp.user !== '') {
      updatedEmp = updatedEmp.filter(d => d.usuario && d.usuario.toLowerCase().includes(infoEmp.user.toLowerCase()));
    }
    if (infoEmp.nombre && infoEmp.nombre !== '') {
      updatedEmp = updatedEmp.filter(d => d.nombre && d.nombre.toLowerCase().includes(infoEmp.nombre.toLowerCase()));
    }
    if (infoEmp.apellido && infoEmp.apellido !== '') {
      updatedEmp = updatedEmp.filter(d => d.apellido && d.apellido.toLowerCase().includes(infoEmp.apellido.toLowerCase()));
    }
    if (infoEmp.area) {
      const areaFiltro = infoEmp.area.toLowerCase();
      updatedEmp = updatedEmp.filter(d => d.area?.toLowerCase() === areaFiltro);
    }
    if (infoEmp.depto) {
      const deptoFiltro = infoEmp.depto.toLowerCase();
      updatedEmp = updatedEmp.filter(d => d.depto?.toLowerCase() === deptoFiltro);
    }
  };
  conFiltro();
  const [vistaEmp, setVistaEmp] = useState(0);
  const [vistaUser, setVistaUser] = useState(0);
  const [vistaLogs, setVistaLogs] = useState(0);
  const [vistaAI, setVistaAI] = useState(0);
  const [aiApiKey, setAiApiKey] = useState(null);
  const [aiPrompt, setAiPrompt] = useState(null);
  const [aiModel, setAiModel] = useState(localStorage.getItem('ai_model') || 'gemini-1.5-flash');
  useEffect(() => {
    const fetchData = async () => {
      try {
        const iaDb = await axios.get('https://back.agsseguros.online/ai');
        setAiApiKey(iaDb.data.data.API_KEY);
        setAiPrompt(iaDb.data.data.PROMPT);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchData();
  }, []);
  const handleSaveAIConfig = async () => {
    try {
      await axios.post('https://back.agsseguros.online/ai', {
        API_KEY: aiApiKey,
        PROMPT: aiPrompt,
      });
      Swal.fire({
        icon: 'success',
        title: 'Configuración guardada',
        text: 'La API Key, el Modelo y el Prompt del Asistente IA se guardaron correctamente.',
        confirmButtonColor: '#42C3BA',
      });
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo guardar la configuración.',
        confirmButtonColor: '#42C3BA',
      });
    }
  };
  const handleValidar = (usuario, actualizarLista) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Está seguro que desea validar el mail ${usuario.email}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, validar',
      cancelButtonText: 'Cancelar',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          // Hacemos la petición POST enviando el ID en el body
          const response = await axios.post('https://reclamosback.agsseguros.online/apiReclamos/user/validar-email-ajustes', { id: usuario.id });

          if (response.data.success) {
            Swal.fire('¡Validado!', response.data.message, 'success');
            window.location.reload();
          } else {
            // Si el backend responde con success: false (ej: "El usuario ya fue validado")
            Swal.fire('Atención', response.data.message, 'info');
          }
        } catch (error) {
          console.error('Error al validar:', error);
          Swal.fire('Error', 'Hubo un error al intentar conectar con el servidor.', 'error');
        }
      }
    });
  };
  
  return (
    <>
      <main className='mainTablaLight'>
        <div className='d-flex align-items-center justify-content-end' style={{ gap: '13px' }}>
          <Link to='/solicitudes' className='botonTablaHeaderDark center' style={{ textDecoration: 'none' }}>
            RECLAMOS
          </Link>
          <Link to='/' className='botonTablaHeaderDark center' style={{ textDecoration: 'none' }}>
            TABLA
          </Link>
        </div>
        {vistaEmp === 1 ? (
          <section className='botonAjustesCerrado' style={{ width: '100%', height: 'auto', padding: '10px', marginTop: '40px' }}>
            <button className='center m-auto' style={{ border: 'none', background: 'none', paddingBottom: '20px' }} onClick={() => setVistaEmp(0)}>
              Cerrar Usuarios Empleados
            </button>
            <div className='d-flex gap-3'>
              <div className='w-100'>
                <label className='d-block'>Nombre</label>
                <input type='text' name='nombre' className='form-control' value={infoEmp.nombre} onChange={handleChangeEmp} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Apellido</label>
                <input type='text' name='apellido' className='form-control' value={infoEmp.apellido} onChange={handleChangeEmp} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Usuario</label>
                <input type='text' name='user' className='form-control' value={infoEmp.user} onChange={handleChangeEmp} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Email</label>
                <input type='text' name='email' className='form-control' value={infoEmp.email} onChange={handleChangeEmp} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Area</label>
                <select name='area' className='form-select' value={infoEmp.area} onChange={handleChangeEmp}>
                  <option value=''>Seleccionar</option>
                  <option value='Administracion'>Administracion</option>
                  <option value='Siniestros'>Siniestros</option>
                  <option value='Comercial'>Comercial</option>
                  <option value='Cobranzas'>Cobranzas</option>
                </select>
              </div>
              <div className='w-100'>
                <label className='d-block'>Depto</label>
                <select name='depto' className='form-select' value={infoEmp.depto} onChange={handleChangeEmp}>
                  <option value=''>Seleccionar</option>
                  <option value='contractuales'>Contractuales</option>
                  <option value='cargas'>Cargas</option>
                  <option value='choques'>Choques</option>
                  <option value='admin'>Admin</option>
                </select>
              </div>
            </div>
            <div style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '40px' }}>
              <table className='table table-striped table-bordered align-middle mb-0'>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                  <tr>
                    <th>Usuario</th>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Email</th>
                    <th>Area</th>
                    <th>Depto</th>
                    <th>Digi</th>
                    <th>Password</th>
                    <th>Codigos Permitidos</th>
                  </tr>
                </thead>
                <tbody>
                  {updatedEmp.map(item => (
                    <tr key={item.id} id={`emp-${item.id}`}>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.usuario}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.nombre}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.apellido}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.email}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.area}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.depto}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.digi}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.password}
                      </td>
                      <td className='w-100' style={{}}>
                        {item.codigosPermitidos}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ) : (
          <button className='botonAjustesCerrado' onClick={() => setVistaEmp(1)}>
            Ver Usuarios Empleados
          </button>
        )}
        {vistaUser === 1 ? (
          <section style={{ marginTop: '80px', width: '100%', height: 'auto', padding: '10px' }} className='botonAjustesCerrado'>
            <button className='center m-auto' style={{ border: 'none', background: 'none', paddingBottom: '20px' }} onClick={() => setVistaUser(0)}>
              Cerrar Usuarios Reclamos
            </button>
            <div className='d-flex gap-3 w-50'>
              <div className='w-100'>
                <label className='d-block'>Nombre</label>
                <input type='text' name='nombre' className='form-control' value={infoUser.nombre} onChange={handleChangeUser} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Apellido</label>
                <input type='text' name='apellido' className='form-control' value={infoUser.apellido} onChange={handleChangeUser} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Email</label>
                <input type='text' name='email' className='form-control' value={infoUser.email} onChange={handleChangeUser} />
              </div>
            </div>
            <div style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '40px' }}>
              <table className='table table-striped table-bordered align-middle mb-0'>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                  <tr>
                    <th>id</th>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Telefono</th>
                    <th>DNI</th>
                    <th>Email</th>
                    <th>Password</th>
                    {cookies.user?.id === 1 && <th>Validado</th>}
                  </tr>
                </thead>
                <tbody>
                  {updatedUser.map(item => (
                    <tr key={item.id} id={`usuario-${item.id}`}>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.id}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.nombre}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.apellido}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.telefono}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.dni}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.email}
                      </td>
                      <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.password}
                      </td>
                      {cookies.user?.id === 1 && (
                        <td className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {item.fueValidado === 1 ? (
                            <span className='text-success fw-bold'>SI</span>
                          ) : (
                            <button className='btn btn-sm btn-primary w-100 text-truncate' onClick={() => handleValidar(item)}>
                              Validar
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ) : (
          <button className='botonAjustesCerrado' style={{ marginTop: '80px' }} onClick={() => setVistaUser(1)}>
            Ver Usuarios Reclamos
          </button>
        )}
        {vistaLogs === 1 ? (
          <section style={{ marginTop: '80px', paddingBottom: '40px', width: '100%', height: 'auto', padding: '10px', marginBottom: '80px' }} className='botonAjustesCerrado'>
            <button className='center m-auto' style={{ border: 'none', background: 'none', paddingBottom: '20px' }} onClick={() => setVistaLogs(0)}>
              Cerrar Logs Completos
            </button>
            <div className='d-flex gap-3'>
              <div className='w-100'>
                <label className='d-block'>Nro Stro</label>
                <input type='number' name='nroStro' className='form-control' value={info.nroStro} onChange={handleChange} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Patente 3ro</label>
                <input type='text' name='patente3ro' className='form-control' value={info.patente3ro} onChange={handleChange} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Fecha Completo</label>
                <input type='date' name='fechaCompleto' className='form-control' value={info.fechaCompleto} onChange={handleChange} />
              </div>
              <div className='w-100'>
                <label className='d-block'>Enviado a Sharepoint</label>
                <select name='enviadoSharepoint' className='form-select' value={info.enviadoSharepoint} onChange={handleChange}>
                  <option value=''>Seleccionar</option>
                  <option value={true}>SI</option>
                  <option value={false}>NO</option>
                </select>
              </div>
              <div className='w-100'>
                <label className='d-block'>Enviado a Digi</label>
                <select name='enviadoDigi' className='form-select' value={info.enviadoDigi} onChange={handleChange}>
                  <option value=''>Seleccionar</option>
                  <option value={true}>SI</option>
                  <option value={false}>NO</option>
                </select>
              </div>
              <div className='w-100'>
                <label className='d-block'>Borrado de VPS</label>
                <select name='borradoVPS' className='form-select' value={info.borradoVPS} onChange={handleChange}>
                  <option value=''>Seleccionar</option>
                  <option value={true}>SI</option>
                  <option value={false}>NO</option>
                </select>
              </div>
              <div className='w-100'>
                <label className='d-block'>Fecha Borrado VPS</label>
                <input type='date' name='fechaBorradoVPS' className='form-control' value={info.fechaBorradoVPS} onChange={handleChange} />
              </div>
            </div>
            <div style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '40px' }}>
              <table className='table table-striped table-bordered align-middle mb-0'>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                  <tr>
                    <th style={{ width: '100px' }}>idReclamo</th>
                    <th>Uuid</th>
                    <th style={{ width: '80px' }}>Id User</th>
                    <th style={{ width: '100px' }}>Stro</th>
                    <th style={{ width: '120px' }}>Patente 3ro</th>
                    <th>Fecha Completo</th>
                    <th style={{ width: '100px' }}>Size Docs</th>
                    <th style={{ width: '120px' }}>Enviado a Sharepoint</th>
                    <th>Sharepoint Error</th>
                    <th style={{ width: '120px' }}>Enviado a Digi</th>
                    <th>Digi Error</th>
                    <th style={{ width: '120px' }}>Borrado de la VPS</th>
                    <th>Fecha Borrado VPS</th>
                  </tr>
                </thead>
                <tbody>
                  {updatedList.map(item => (
                    <tr key={item.id}>
                      <td style={{ width: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.idReclamo}>
                        {item.idReclamo}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.uuid}>
                        {item.uuid}
                      </td>
                      <td
                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', width: '80px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={`Ir al usuario ${item.idUser}`}
                        onClick={() => {
                          if (vistaUser === 0) {
                            setVistaUser(1);
                            setTimeout(() => {
                              const userRow = document.getElementById(`usuario-${item.idUser}`);
                              if (userRow) {
                                userRow.scrollIntoView({
                                  behavior: 'smooth',
                                  block: 'center',
                                  inline: 'center',
                                });
                                userRow.classList.remove('user-highlight');
                                void userRow.offsetWidth;
                                userRow.classList.add('user-highlight');
                                setTimeout(() => {
                                  userRow.classList.remove('user-highlight');
                                }, 4000);
                              }
                            }, 200);
                          } else {
                            const userRow = document.getElementById(`usuario-${item.idUser}`);
                            if (userRow) {
                              userRow.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center',
                              });
                              userRow.classList.remove('user-highlight');
                              void userRow.offsetWidth;
                              userRow.classList.add('user-highlight');
                              setTimeout(() => {
                                userRow.classList.remove('user-highlight');
                              }, 4000);
                            }
                          }
                        }}>
                        {item.idUser}
                      </td>
                      <td style={{ width: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.nroStro}>
                        {item.nroStro}
                      </td>
                      <td style={{ width: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.patente3ro}>
                        {item.patente3ro}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.fechaCompleto}>
                        {item.fechaCompleto ? item.fechaCompleto.split('-').reverse().join('/') : '-'}
                      </td>
                      <td style={{ width: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.sizeDocs}>
                        {item.sizeDocs}
                      </td>
                      <td style={{ width: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.sharepointCompleto ? 'SI' : 'NO'}>
                        {item.sharepointCompleto ? 'SI' : 'NO'}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.sharepointLogError}>
                        {item.sharepointLogError}
                      </td>
                      <td style={{ width: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.enviadoDigi ? 'SI' : 'NO'}>
                        {item.enviadoDigi ? 'SI' : 'NO'}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.logErrorDigi}>
                        {item.logErrorDigi}
                      </td>
                      <td style={{ width: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.borrado ? 'SI' : 'NO'}>
                        {item.borrado ? 'SI' : 'NO'}
                      </td>
                      <td
                        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={item.fechaBorrado && item.fechaBorrado !== '0000-00-00' ? item.fechaBorrado.split('-').reverse().join('/') : ''}>
                        {item.fechaBorrado && item.fechaBorrado !== '0000-00-00' ? item.fechaBorrado.split('-').reverse().join('/') : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ) : (
          <button className='botonAjustesCerrado' style={{ marginTop: '80px' }} onClick={() => setVistaLogs(1)}>
            Ver Logs Completos
          </button>
        )}
        {vistaAI === 1 ? (
          <section style={{ marginTop: '80px', width: '100%', height: 'auto', padding: '20px', marginBottom: '80px' }} className='botonAjustesCerrado'>
            <button className='center m-auto d-block' style={{ border: 'none', background: 'none', paddingBottom: '20px' }} onClick={() => setVistaAI(0)}>
              Cerrar Configuración Asistente IA
            </button>
            <div className='w-100 mb-3 text-start' style={{ textAlign: 'left' }}>
              <label className='d-block font-weight-bold mb-1'>Gemini API Key</label>
              <input type='password' className='form-control' placeholder='Ingrese su API Key de Gemini...' value={aiApiKey} onChange={e => setAiApiKey(e.target.value)} />
            </div>
            <div className='w-100 mb-3 text-start' style={{ textAlign: 'left' }}>
              <label className='d-block font-weight-bold mb-1'>Modelo de Gemini</label>
              <select className='form-select mb-2' value={aiModel} onChange={e => setAiModel(e.target.value)}>
                <option value='gemini-1.5-flash'>gemini-1.5-flash (Por defecto)</option>
                <option value='gemini-2.5-flash'>gemini-2.5-flash (Recomendado)</option>
                <option value='gemini-2.0-flash'>gemini-2.0-flash</option>
                <option value='gemini-1.5-pro'>gemini-1.5-pro</option>
                <option value='custom'>Otro modelo (ingresar a mano)</option>
              </select>
              {(!['gemini-1.5-flash', 'gemini-2.5-flash', 'gemini-2.0-flash', 'gemini-1.5-pro'].includes(aiModel) || aiModel === 'custom') && (
                <input
                  type='text'
                  className='form-control mt-2'
                  placeholder='Escriba el nombre exacto del modelo (ej. gemini-1.5-flash-latest)...'
                  value={aiModel === 'custom' ? '' : aiModel}
                  onChange={e => setAiModel(e.target.value)}
                />
              )}
            </div>
            <div className='w-100 mb-3 text-start' style={{ textAlign: 'left' }}>
              <label className='d-block font-weight-bold mb-1'>Prompt Base / Instrucciones del Sistema</label>
              <textarea className='form-control' rows={6} placeholder='Ingrese las instrucciones base para el Asistente IA...' value={aiPrompt} onChange={e => setAiPrompt(e.target.value)} />
              <small className='text-muted d-block mt-1'>
                Este prompt servirá como la instrucción base para el Asistente IA. Se le inyectarán de forma automática los datos generales del siniestro, los estados y el historial de la cronología.
              </small>
            </div>
            <button className='btn btn-primary mt-2 d-block mx-auto' style={{ backgroundColor: '#42C3BA', borderColor: '#42C3BA' }} onClick={handleSaveAIConfig}>
              Guardar Configuración
            </button>
          </section>
        ) : (
          <button className='botonAjustesCerrado' style={{ marginTop: '80px', marginBottom: '80px' }} onClick={() => setVistaAI(1)}>
            Configuración Asistente IA
          </button>
        )}
      </main>
    </>
  );
}
